// extracted by mini-css-extract-plugin
export default {"card":"J4-z"};